import React from 'react';
import { Link } from 'react-router-dom';
import './app-logo.css';

export const APP_LOGO_PATH = `${process.env.PUBLIC_URL}/logo_transparent.png`;
export const APP_BRAND_NAME = 'Innovative Info Solutions';

const AppLogo = ({
  to = '/',
  variant = 'header',
  showText,
  className = '',
  onClick,
}) => {
  const showLabel = showText ?? !['icon'].includes(variant);
  const classes = ['app-logo', `app-logo--${variant}`, className].filter(Boolean).join(' ');

  const content = (
    <>
      <img
        src={APP_LOGO_PATH}
        alt={showLabel ? '' : APP_BRAND_NAME}
        className="app-logo__img"
        aria-hidden={showLabel || undefined}
      />
      {showLabel && (
        <span className="app-logo__text">
          INNOVATIVE
          <strong> INFO SOLUTIONS</strong>
        </span>
      )}
    </>
  );

  if (to) {
    return (
      <Link
        to={to}
        className={classes}
        aria-label={`${APP_BRAND_NAME} home`}
        onClick={onClick}
      >
        {content}
      </Link>
    );
  }

  return <div className={classes}>{content}</div>;
};

export default AppLogo;
